<script setup lang="ts">
import StatBlock from "@/components/modules/Analytics/Charts/StatBlock.vue";
import DynamicByMonth from "@/components/modules/Analytics/Charts/DynamicByMonth.vue";
import RegionTop from "@/components/modules/Analytics/Charts/RegionTop.vue";
import {CasesAcceptedAnalyticProps} from "@/types/analytics";

defineProps<CasesAcceptedAnalyticProps>();
</script>

<template>
  <div class="params">
    <div class="params__wrapper">
      <StatBlock
        title="принято новых дел к производству"
        :value="analyticData.totalData?.total_accepted?.value"
        :percent="analyticData.totalData?.total_accepted?.percent_to_previous"
        :is-appg="false"
        :is-main="true"
      />
      <StatBlock
        title="удельный вес от дел в производстве"
        :value="analyticData.totalData?.accepted_of_proceedings?.value"
        :percent="analyticData.totalData?.accepted_of_proceedings?.percent_to_previous"
        :is-appg="true"
      />
      <StatBlock
        title="передано прокурором для производства предварительного следствия"
        :value="analyticData.totalData?.transferred_by_prosecutor?.value"
        :percent="analyticData.totalData?.transferred_by_prosecutor?.percent_to_previous"
        :is-appg="false"
      />
      <StatBlock
        title="удельный вес от числа принятых"
        :value="analyticData.totalData?.transferred_by_prosecutor_of_accepted?.value"
        :percent="analyticData.totalData?.transferred_by_prosecutor_of_accepted?.percent_to_previous"
        :is-appg="true"
      />
    </div>

    <DynamicByMonth
      :active-type="activeType"
      :selected-region="selectedRegion"
      :selected-district="selectedDistrict"
      :dynamic="analyticData.monthlyDynamic"
    />
    <template v-if="activeType !== 'region'">
      <RegionTop
        sort-order="desc"
        :active-type="activeType"
        :selected-district="selectedDistrict"
        :region-list="analyticData.topDescending"
      />
      <RegionTop
        sort-order="asc"
        :active-type="activeType"
        :selected-district="selectedDistrict"
        :region-list="analyticData.topAscending"
      />
    </template>
  </div>
</template>

<style scoped lang="scss">
.params {
  display: flex;
  flex-direction: column;
  gap: 12px;
  height: 100%;

  &__wrapper {
    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-gap: 12px;
    margin-top: auto;
  }
}
</style>